<template>
  <div class="aboutus-page">
    <!-- ARS -->
    <div class="my-5"></div>

    <section class="pb-xl-5 mb-5 mx-lg-3">
      <div class="mt-10 px-4 px-xl-0">
        <div class="title-big text-center"><h1>About Aliff</h1></div>
        <div class="goals text-center mt-5">
          <div class="vision">
            <div class="orange-title">our vision</div>
            <p class="goal-para">
              To become the world leader in connecting Students &amp;
              Universities.
            </p>
          </div>
          <div class="mission">
            <div class="orange-title">our mission</div>
            <p class="goal-para">
              Guide ambitious students to choose the Right Course, College &
              Country leading to a global career, without having to spend a
              fortune & worrying about their grades.
            </p>
          </div>
        </div>
        <div class="city flex-center mt-5">
          <img src="@/assets/imgs/city.png" alt="" />
        </div>
      </div>
    </section>

    <section class="core-values-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <h2 class="main-heading-1-gradient text-center">our core values</h2>

          </div>
          <div class="col-lg-12 mt-2 pt-xl-3 text-center">
            <ul class="core-cards">
              <li class="values">
                <img class="mb-2" src="@/assets/imgs/layers.png" alt="" />
                <h3 class="card-title">student first</h3>
                <p class="card-para">
                  Save the aspirant’s money &amp; effort through expert guidance
                  and advanced technology support
                </p>
              </li>
              <li class="values">
                <img class="mb-2" src="@/assets/imgs/magin-wand.png" alt="" />
                <h3 class="card-title">Transparency</h3>
                <p class="card-para">
                  Honest clear communication with all stakeholders
                </p>
              </li>
              <li class="values">
                <img class="mb-2" src="@/assets/imgs/heart.png" alt="" />
                <h3 class="card-title">research &amp; innovation</h3>
                <p class="card-para">
                  About futurist courses, modern universities &amp; favourable
                  foreign policies
                </p>
              </li>
              <li class="values">
                <img class="mb-2" src="@/assets/imgs/layers.png" alt="" />
                <h3 class="card-title">passion</h3>
                <p class="card-para">Showcase during any form of interaction</p>
              </li>
              <li class="values">
                <img class="mb-2" src="@/assets/imgs/magin-wand.png" alt="" />
                <h3 class="card-title">go the extra mile</h3>
                <p class="card-para">
                  To make every student’s journey with Aliff enjoyable &amp;
                  memorable
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mt-5 pb-xl-5 mb-5 mx-lg-3">
      <div class="ml-xl-5 px-4 px-xl-0">
        <div class="introduction">
          <div class="intro-para">
            <h1 class="main-heading-1-gradient mb-2">Introduction</h1>
            <p class="intro-para">
              Aliff, the first letter of Arabic &amp; Urdu language, signifies
              the Beginning. Holding the ethos of the word at the soul of the
              organization, what began as a dream project in the previous decade
              is today helping students begin a career of their dreams, every
              minute! Aliff has helped &amp; garnered the dreams of 23,000+
              students to choose the right career. Aliff’s unique value pyramid
              3C model helps students choose the Right Course, Right College,
              Right Country, anywhere in the world.
            </p>
          </div>
          <div class="intro-img">
            <img src="@/assets/imgs/introduction.png" alt="" />
          </div>
        </div>
      </div>
    </section>
    <section class="pb-xl-4 mb-5 mx-lg-2 p-4">
      <div class="gradient-box bg-primary-gradient">
        <div class="box-title p-5">
          <h1 class="mb-1">
            Aliff <br />
            Milestones
          </h1>
          <p class="ratings">
            4.7/5 <img src="@/assets/imgs/rating.png" alt="" /> <br />
          </p>
          <p>Google Rating</p>
        </div>
        <div class="box-content">
          <ul class="content-list">
            <li class="content mb-4">
              <h1>10+</h1>
              <p>Years of experience</p>
            </li>
            <li class="content mb-4">
              <h1>100%</h1>
              <p>Admission Succcess Rate</p>
            </li>
            <li class="content mb-4">
              <h1>14</h1>
              <p>Easy-access Countries</p>
            </li>
            <li class="content mb-4">
              <h1>Top 10</h1>
              <p>Full Scholarship Students</p>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- AWARDS AND RECOGNITIONS -->
    <section class="container">
      <h2 class="main-heading-1-gradient text-center mb-5">
        Awards and Recognitions
      </h2>
      <div class="awards-display card-columns">
        <div>
          <img
            src="@/assets/imgs/awards/award-1.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-2.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-3.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-4.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-5.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-6.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img src="@/assets/imgs/awards/award-7.5.jpg" class="img-fluid" />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-7.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-8.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-9.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-10.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-11.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div>
          <img
            src="@/assets/imgs/awards/award-12.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
      </div>
      <!-- <div>
        <img src="@/assets/imgs/awards/award-13.jpg" class="img-fluid" alt="" />
      </div> -->
    </section>

    <!-- <section class="awards-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <h2 class="main-heading-1-gradient text-center">
              Awards and Recognitions
            </h2> -->
    <!-- <p class="main-content-1">
                A line to speak about featured destination, programme, or
                university. A line to speak about featured destination, programme,
                or university
              </p> -->
    <!-- </div> -->
    <!-- <div class="col-lg-12 col-md-6 mt-5 pt-xl-5">
            <div class="team-member-cards">
              <ul class="cards">
                <li>
                  <img src="@/assets/imgs/awards-1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-3.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-4.png" alt="" />
                </li>
              </ul>
              <ul class="cards">
                <li>
                  <img src="@/assets/imgs/awards-5.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-6.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-7.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-8.png" alt="" />
                </li>
              </ul>
            </div>
          </div> -->
    <!-- </div>
      </div>
    </section> -->
    <section class="founder-section section-spacing">
      <div class="container">
        <!-- <div class="row"> -->
        <!-- <div class="col-lg"> -->
        <!-- <div> -->
        <h2 class="main-heading-1-gradient text-center">About the Founder</h2>
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <div class="row mt-5 align-items-center">
          <div class="col-lg-4 responsive-img">
            <img
              src="@/assets/imgs/aslam-founder.png"
              class="img-fluid border-20"
            />
          </div>
          <div class="col-lg-8 founder-intro">
            <h4 class="font-weight-bold">Mr. Asslam Shaikh</h4>
            <h6 class="primary-color pt-2">Founder & CEO</h6>
            <p class="main-content-1 pt-3">
              Asslam I Shaikh Mr Asslam is a young edupreneur. He has over a
              decade of experience in the field of education & has travelled to
              over 14 countries. He was listed among Top 10 Best Consulting
              Leaders by Knowledge Review & Won ‘Genius’ award by Times
              Education. He is a certified Global consultant by ICEF Germany &
              British Council.
              <br /><br />
              <i
                >“My passion is to help ambitious students to join top-ranking
                international universities so that they can easily earn 6 figure
                salaries without wasting time or spending a fortune & worrying
                about their marks"</i
              >
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="leadership-team--section section-spacing">
      <div class="container">
        <h2 class="main-heading-1-gradient text-center">Leadership Team</h2>
        <div class="row">
          <div class="col-lg-12 mt-3 pt-xl-5">
            <div class="leadership-team-member-cards">
              <div class="cards row">
                <div class="col-lg-6 team-member">
                  <img src="@/assets/imgs/Utpaal.png" alt="" />
                  <div class="h4 font-weight-bold m-0">Utpal Acharya</div>
                  <p class="designation designation-orange">
                    Chief Strategy Officer
                  </p>
                  <!-- <hr /> -->
                  <ul class="list-unstyled">
                    <li>JNU &amp; NMIMS Alumnus</li>
                    <li>Ex country Head - Reliance Entertainment (D&amp;A)</li>
                  </ul>
                </div>
                <div class="col-lg-6 team-member">
                  <img src="@/assets/imgs/jenny.png" alt="" />
                  <div class="h4 font-weight-bold m-0">Jenny Dsa</div>
                  <p class="designation designation-orange">Head of Products</p>
                  <!-- <hr /> -->
                  <ul class="list-unstyled">
                    <li>12+ years of experience in Study Abroad Industry</li>
                  </ul>
                </div>
                <div class="col-lg-6 team-member">
                  <img src="@/assets/imgs/Arshad-1.png" alt="" />
                  <div class="h4 font-weight-bold m-0">Arshad Kazi</div>
                  <p class="designation designation-orange">
                    Chief Technology Officer
                  </p>
                  <!-- <hr /> -->
                  <ul class="list-unstyled">
                    <li>Ex Director Technology - Conde Nast India</li>
                  </ul>
                </div>
                <div class="col-lg-6 team-member">
                  <img src="@/assets/imgs/Sanath.png" alt="" />
                  <div class="h4 font-weight-bold m-0">Sanath Shetty</div>
                  <p class="designation designation-orange">
                    Head of Engineering
                  </p>
                  <!-- <hr /> -->
                  <ul class="list-unstyled">
                    <li>BITS Pilani Alumnus</li>
                  </ul>
                </div>
                <!-- <div class="col-lg-4 team-member">
                  <img src="@/assets/imgs/kaustah.png" alt="" />
                  <div class="h4 font-weight-bold m-0">Kaustubh K Murkar</div>
                  <p class="designation designation-orange mt-1">
                    HOD - Media Strategy & Events
                  </p>
                </div>
                <div class="col-lg-4 team-member">
                  <div class="team-member">
                    <img src="@/assets/imgs/neha-1.png" alt="" />
                    <div class="h4 font-weight-bold m-0">Neha Ved</div>
                    <p class="designation designation-orange">
                      Head of Communication
                    </p>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="d-none franchise-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div
            class="col-lg-6 text-center"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 class="main-heading-1-gradient text-center">
              Aliff Franchise Partners
            </h2>
            <!-- <p class="main-content-1">
                We are a group of experienced and passionate people bringing our
                best counsel to help every kid realize their true potential. We go
                that extra mile to fulfil our aim of making the overseas education
                journey for every student, simple and effective.
              </p> -->
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <div class="team-member-cards">
              <slick
                ref="teamIntroSlider"
                :options="teamIntroSlider"
                class="stu-card-slider green-slick-dots franchise-card-slider"
              >
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/1.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>83569 91403</span></p>
                        <p><span>preeti@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Preeti Ganju</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/2.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>83569 73171</span></p>
                        <p><span>lopa@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Lopa Vyas</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/3.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>93213 06252</span></p>
                        <p><span>shabana@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Shabana Khan</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/4.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>93268 60910</span></p>
                        <p><span>worli@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Snehas Ajgaonkar</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/5.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number">
                          <span> 971 50 781 3413, 971 58 580 5879</span>
                        </p>
                        <p><span>dubai@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Shalini Singh</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/6.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number">
                          <span>965 506 33207</span>
                        </p>
                        <p>hina@aliff.in</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Hina Saleem</p>
                  </div>
                </div>
              </slick>
            </div>
            <!-- <div class="text-center pt-3">
                <button
                  @click="() => $router.push({ path: '/about-us' })"
                  class="btn-secondary-red"
                >
                  Get to know us
                </button>
              </div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="board-section section-spacing">
      <div class="container">
        <h2 class="main-heading-1-gradient text-center">Board of Advisors</h2>

        <div class="row">

<!-- Neeraj Shah -->
<div class="col-12 col-md-6 col-lg-4">
  <div class=" text-center">
    <img src="@/assets/imgs/neeraj shah.png" alt="" />
    <h4 class="bold">Neeraj Shah</h4>
    <p class="mt-3 fs-14 lh-175">
      Alumni Merchant Taylor's School &amp; Univ of Bath - UK Ex
      Co-National Director - BNI India
    </p>
  </div>
</div>

<!-- Mansoor Khan -->
<div class="col-12 col-md-6 col-lg-4">
  <div class=" text-center">
    <img src="@/assets/imgs/mansoor khan.png" alt="" />
    <h4 class="bold">Mansoor Khan</h4>
    <p class="mt-3 fs-14 lh-175">
      Founder Director - AMFAH INDIA Regional Product Manager - BPL
      Limited
    </p>
  </div>
</div>

<!-- Zafar Khan -->
<div class="col-12 col-md-6 col-lg-4">
  <div class=" text-center">
    <img src="@/assets/imgs/zafar-khan.png" alt="" />
    <h4 class="bold">Zafar Khan</h4>
    <p class="mt-3 fs-14 lh-175">
      Founding Consultant Jetking Infotrain Ltd. <br />
      Ex Managing Partner Jawed Habib HairXpreso
    </p>
  </div>
</div>

<!-- Himanshu Dev -->
<div class="col-12 col-md-6 col-lg-4">
  <div class=" text-center">
    <img src="@/assets/imgs/himanshu dev.png" alt="" />
    <h4 class="bold">Himanshu Dev</h4>
    <p class="mt-3 fs-14 lh-175">
      Alumni &amp; Ex Lecturer North Caroline State Univ., USA
      Education Advisor - USA High Commission
    </p>
  </div>
</div>


<!-- Dr. Sanjay Kantharia -->
<div class="col-12 col-md-6 col-lg-4">
  <div class=" text-center p-2">
    <img class="" src="@/assets/imgs/boa-5.png" alt="" />
    <h4 class="bold mt-4">Dr. Sanjay Kantharia</h4>
    <p class="mt-3 fs-14 lh-175">
      MBBS & MS Orthopaedic from KEM, Mumbai Experienced Orthopaedic
      surgeon for last 25 years with a passion of Mentoring students
      for better education
    </p>
  </div>
</div>

<!-- Dr. Abdelkhalig Osman Mohamed -->
<div class="col-12 col-md-6 col-lg-4">
  <div class=" text-center">
    <img
      class="boa-img mt-3"
      src="@/assets/imgs/boa-6-modified.png"
      alt=""
    />
    <h5 class="bold mt-4">Dr. Abdelkhalig Osman Mohamed</h5>
    <p class="mt-3 fs-14 lh-175">
      CEO of Gulf conference ltd, London, UK.<br />
      He won many awards for educational growth in MENA region from
      the Saudi Arabian Ministry of Higher Education and Ministry of
      Higher Education UK.
    </p>
  </div>
</div>
</div>
        <!-- <

            </div>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo: {
    title: "About Aliff Overseas | Study Abroad | Coaching & Career Counseling",
    htmlAttrs: {
      lang: "en-US"
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Aliff Overseas offers step-by-step support for ambitious students to join top international universities so that they can easily earn 6 figure salaries. Visit our site to know more!"
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" }
    ]
  },
  data() {
    return {
      tags: [
        "Australia",
        "USA",
        "Germany",
        "MBA",
        "Architecture",
        "Design",
        "B.Tech",
        "Australia",
        "USA",
        "Germany",
        "MBA",
        "Architecture",
        "Australia"
      ],
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      pricingSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      destinationSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      teamIntroSlider: {
        slidesToShow: 4.5,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 0,
        // speed: 5000,
        // cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
        ]
      },
      logoSlider: {
        autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 8,
        autoplaySpeed: 1000,
        centerMode: true,
        centerPadding: "1.875rem",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  }
};
</script>
<style>
.card-columns img {
  margin-bottom: 1.2em;
  border-image: linear-gradient(#4874f2, #0bc2a9) 30;
  border-width: 0.25rem;
  border-style: solid;
}
.boa-img {
  width: 50%;
}
.divider_about {
  width: 6.25rem;
  background-color: #ffa132;
  display: flex;
  justify-content: center;
}
/* .max{
  max-width: 96rem;
} */

.anim-wrapper {
  position: relative;
}

.anim-background-carousel {
  background-image: url("../../assets/imgs/city_without_balloon_320.png");
  background-repeat: repeat-x;
  height: 20rem;
  width: 300%;
  animation: image-slide-animation 30s linear infinite;
}

#balloon {
  position: absolute;
  width: 12.5rem;
  top: 30%;
  left: 40%;
  animation: balloon-animation 8s ease-in-out infinite alternate;
}

@keyframes image-slide-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}

@keyframes balloon-animation {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translate(-50%, -55%);
  }
  100% {
    transform: translate(-75%, -50%);
  }
}

@media screen and (max-width: 30rem) {
  .anim-background-carousel {
    animation: image-slide-animation 5s linear infinite;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Aboutus.vue